import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const getPermissionsRequest = createAction('getPermissionsRequest');
export const setAuthoritiesRequest = createAction('setAuthoritiesRequest');
export const receivedPermissionsFail = createAction('receivedPermissionsFail');
export const addAccessToPageRequest = createAction('ADD_ACCESS_TO_PAGE_REQUEST');
export const receivedPermissionsSuccess = createAction('receivedPermissionsSuccess');
